const KEY = 'ambiental_install_id';

function randomId() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return `web-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
}

export function getInstallId() {
  try {
    let id = localStorage.getItem(KEY);
    if (!id || id.length < 8) {
      id = randomId();
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    return 'web-anonymous';
  }
}
